// extracted by mini-css-extract-plugin
module.exports = {"button":"ColorButton_button__2-rs2","button_active":"ColorButton_button_active__7RH_D","button__number":"ColorButton_button__number__v7stF"};